// extracted by mini-css-extract-plugin
export default {"button":"button_button__yrQei","withIcon":"button_withIcon__T6uml","icon":"button_icon__TMwIu","onlyIcon":"button_onlyIcon__CbjW8"};